import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { JacClientErrorBoundary, ErrorFallback, AuthGuard, __jacInstallErrorHandlers, __jacReactErrorHandler } from "@jac/runtime";
import { routes, layouts } from "./_routes.js";
import { app as AppWrapper } from "./main.js";

__jacInstallErrorHandlers();

const publicRoutes = routes.filter(r => !r.auth);
const authRoutes = routes.filter(r => r.auth);
const RootLayout = layouts["/"] || null;

function renderRoutes(routeList) {
	return routeList.map(r =>
		React.createElement(Route, { key: r.path, path: r.path, element: React.createElement(r.element, null) })
	);
}

function _AuthGuardRoute() { return AuthGuard("/login"); }
const authGuardElement = React.createElement(_AuthGuardRoute, null);

function App() {
	const routeChildren = [
		...renderRoutes(publicRoutes),
		React.createElement(Route, { key: "__auth", element: authGuardElement },
			...renderRoutes(authRoutes)
		),
	];

	const routeTree = RootLayout
		? React.createElement(Route, { element: React.createElement(RootLayout, null) }, ...routeChildren)
		: routeChildren;

	return React.createElement(BrowserRouter, null,
		React.createElement(Routes, null,
			...(Array.isArray(routeTree) ? routeTree : [routeTree])
		)
	);
}

const appElement = React.createElement(AppWrapper, null, React.createElement(App, null));

const root = createRoot(document.getElementById("root"));
root.render(
	React.createElement(JacClientErrorBoundary, { FallbackComponent: ErrorFallback, onError: __jacReactErrorHandler }, appElement)
);
